import { useSelector } from 'react-redux';
import { Navigate, useParams } from 'react-router-dom';
import { PATH } from 'src/constants/Path';
import { useEnv, useRoute, useSwitchEnv } from 'src/hooks';
import { RootState } from 'src/redux/reducers/rootReducer';

export function DemoRoute() {
  let params = useParams();
  const auth = useSelector((state: RootState) => state.auth);
  const { user } = auth;

  const { switchToDemo } = useSwitchEnv();
  const { isProdEnv } = useEnv();

  const { state, redirectUrl } = useRoute();
  const { isRedirect, isUserLoggedOut } = state;

  if (isRedirect || isUserLoggedOut)
    return <Navigate to={redirectUrl()} replace />;

  const mainUrl = `/${params['*']}`;
  const sessionExpiredUrl = `${PATH.home}?redirect_link=/demo${mainUrl}`;

  const switchEnv = async () => {
    await switchToDemo(user?.username ?? '', mainUrl, sessionExpiredUrl);
    return <></>;
  };

  if (isProdEnv) switchEnv();

  return <Navigate to={mainUrl} replace />;
}
